// default
export const WORKER = 'worker';
export const WORKER_SLICE_NAME = `${WORKER}Slice`;

// action
export const GET_WORKERS = `${WORKER}/getWorkers`;
export const GET_WORKERS_ADMINS = `${WORKER}/getWorkersAdmins`;
export const GET_WORKER_DETAIL = `${WORKER}/getWorkerDetail`;
export const GET_WORKERS_BY_SAFETY_ID = `${WORKER}/getWorkersBySafetyId`;
export const GET_WORKER_SAFETY_HISTORIES = `${WORKER}/getWorkerSafetyHistories`;
export const GET_WORKER_DOWNLOAD = `${WORKER}/getWorkerDownload`;
// const CREATE_WOKER = `${WORKER}/postWoker`;
// const UPEATE_WOKER = `${WORKER}/updateWoker`;
// const DELETE_WOKER = `${WORKER}/deleteWoker`;

// actions
export const actions = {
  GET_WORKERS,
  GET_WORKERS_ADMINS,
  GET_WORKER_DETAIL,
  GET_WORKERS_BY_SAFETY_ID,
  GET_WORKER_SAFETY_HISTORIES,
  GET_WORKER_DOWNLOAD
};
